<template>
	<el-container style="background-color: #EEEEEE;min-height:100%;">
		<el-header class="result-header">
			<span class="back-btn" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
		</el-header>
		<el-main class="result-main">
			<div class="result-body" @scroll="scrollEvent" id="resultBox">
				<div class="result-body-left">
					<div class="result-body-header">
						<p class="paper-title">
							<b>{{paper_title}}</b>
							<template v-if="!is_read && submit_time">
                                <img :src="require('../../assets/imgs/stay.png')" class="status-imgs"/>
                            </template>
							</p>
						<i class="divider-line"></i>
						<div class="student-info">
							<span class="info-item">姓名: {{student_name}}</span>|
							<span class="info-item">用时：{{usedTime}}</span> |
							<span class="info-item">分值占比：{{percent}}</span> |
							<span class="info-item">得分：{{student_score}}</span>
						</div>
						<div class="score-info">
							<div class="info-left">
								<div class="info-left-item">客观成绩</div>
								<div class="info-left-item">主观成绩</div>
							</div>
							<div class="info-content">
								<table class="objective-table" border="1">
									<thead>
										<tr>
											<td v-for="(it,i) in objective_score" :key="i">
												<span>{{it.typeName}}</span>
												<span>({{it.single_score}}分)</span>
											</td>
											<td>
												<span>客观总分</span>
											</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td v-for="(it,i) in objective_score" :key="i">{{it.get_score}}</td>
											<td>{{objScore}}</td>
										</tr>
									</tbody>
								</table>
								<table class="subjective-table" border="1">
									<thead>
										<tr>
											<td v-for="(it,i) in subjective_score" :key="i">
												<span>{{it.typeName}}</span>
												<span>({{it.single_score}}分)</span>
											</td>
											<td>
												<span>主观总分</span>
											</td>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td v-for="(it,i) in subjective_score" :key="i">{{it.get_score}}</td>
											<td>{{subScore}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="info-right">
								<div class="info-right-up">
									成绩
								</div>
								<div class="info-right-down">
									{{objScore+subScore}}
								</div>
							</div>
						</div>
						<div class="answer-list">
							<ul class="answer-list-box">
								<li class="answer-list-options" v-for="(item,index) in answerBtn" :key="index">
									<span @click="checkQuestion(item.index,item.type,index)" :class="jugeStatus(index,item.status,item.isRight)">{{index+1}}</span>
								</li>
								<div style="clear: both;"></div>
							</ul>
						</div>
					</div>
					<div class="result-body-content" >
						<div class="content-header">
							<span>【{{questionType | returnType}}】</span>
							<span>({{singleScore}}分)</span>
						</div>
						<template v-for="(item,index) in currentList">
							<template v-if="questionType==1&&index==currentIndex">
								<ScResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :key="index"></ScResult>
							</template>
							<template v-else-if="questionType==2&&index==currentIndex">
								<McResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :key="index"></McResult>
							</template>
							<template v-else-if="questionType==3&&index==currentIndex">
								<JugeResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :key="index"></JugeResult>
							</template>
							<template v-else-if="questionType==4&&index==currentIndex">
								<FillResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :key="index"></FillResult>
							</template>
							<template v-else-if="questionType==7&&index==currentIndex">
								<ShortResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :status="is_read" :type="type" :key="index"></ShortResult>
							</template>
							<template v-else-if="questionType==8&&index==currentIndex">
								<ExplainResult  :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :status="is_read" :type="type" :key="index"></ExplainResult>
							</template>
							<template v-else-if="questionType==9&&index==currentIndex">
								<TrainResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :status="is_read" :type="type" :key="index"></TrainResult>
							</template>
							<template v-else-if="questionType==10&&index==currentIndex">
								<MsResult :itemContent="item" :index="index" :currentIndex="currentExercise" :name="student_name" :key="index"></MsResult>
							</template>
						</template>
					</div>
					<div class="operation-btn">
						<p @click="prevQuestion" v-show="currentExercise>0">上一题</p>
						<p @click="nextQuestion" v-show="currentExercise<totalExercise-1">下一题</p>
						<p @click="backTop" v-show="topTopFixed">返回顶部</p>
					</div>
				</div>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	import {checkPaperResultData,returnQuestionType, returnType,answeIfNull} from "@/api/show"
	import ScResult from "@/components/result/SingleChoiceResult";
	import McResult from "@/components/result/MultipleChoiceResult";
	import MsResult from "@/components/result/MultipleSortResult";
	import FillResult from "@/components/result/FillResult";
	import JugeResult from "@/components/result/JugeMentResult";
	import ShortResult from "@/components/result/ShortResult";
	import ExplainResult from "@/components/result/ExplainResult";
	import TrainResult from "@/components/result/TrainResult";
	export default{
		components:{
			ScResult,
			McResult,
			MsResult,
			FillResult,
			JugeResult,
			ShortResult,
			ExplainResult,
			TrainResult,
		},
		data(){
			return{
				paper_title:'',//试卷名称
				currentExercise:0,//当前题
				totalExercise:0,//总题数
				topTopFixed:false,
				questionType:'',//题目类型
				paperId:'',//试卷id
				student_name:'',//学生名
				competitionId:'',//教师发布到班级的id
				questionList:[],//试卷所有内容
				answerBtn:[],//题目按钮
				currentList:[],//当前类型所有题目
				currentIndex:0,//当前题目在该类型题目中的下标值,默认0
				singleScore:'',//单题分数
				objective_score:[],//客观成绩
				subjective_score:[],//主观成绩
				student_score:'',//学生总分
				subjectiveArr:[7,8,9],//主观题型
				start_time:0,//考试开始时间
				submit_time:0,//学生交卷时间
				type:'contest',//竞赛类型
				is_read:1,//是否已阅读
				percent:'',//分值占比
				replay_type:0,//是否参与重现赛
				times:0,//第几次参与
				classroom_id:0,//专题id
			}
		},
		watch:{
			questionType: function(){
				let ind = this.questionList.findIndex((val)=>{
					return val.paper_type === this.questionType
				})
				if(ind!==-1){
					this.currentList = this.questionList[ind].paper_info
				}
			}
		},
		computed:{
			objScore: function(){
				let score = 0
				for(let i=0;i<this.objective_score.length;i++){
					score += this.objective_score[i].get_score
				}
				return score
			},
			subScore: function(){
				let score = 0
				for(let i=0;i<this.subjective_score.length;i++){
					score += this.subjective_score[i].get_score
				}
				return score
			},
			usedTime: function(){
				if(!this.submit_time){
					return 0;
				}
				let time = this.submit_time - this.start_time
				if(time){
					let nd = 24*3600;
					let nh = 3600;
					let nm = 60;
					let day = Math.floor(time/nd)
					let houre = Math.floor(time%nd/nh)<10?'0'+Math.floor(time%nd/nh):Math.floor(time%nd/nh)
					let minute = Math.floor(time%nd%nh/nm)<10?'0'+Math.floor(time%nd%nh/nm):Math.floor(time%nd%nh/nm)
					let second = Math.floor(time%nd%nh%nm)<10?'0'+Math.floor(time%nd%nh%nm):Math.floor(time%nd%nh%nm)
					if(day){
						return day+'天'+houre+':'+minute+':'+second
					}else{
						return houre+':'+minute+':'+second
					}
				}
			}
		},
		created(){
			if(Object.keys(this.$route.params).length > 0){
				this.paperId = this.$route.params.paperId
				this.competitionId = this.$route.params.competitionId
				this.replay_type = this.$route.params.replay_type
				this.times = this.$route.params.times
				this.classroom_id = this.$route.params.classroomId
				let info = {
					paperId:this.paperId,
					competitionId:this.competitionId,
					replay_type:this.replay_type,
					times:this.times,
					classroom_id:this.classroom_id,
				}
				sessionStorage.setItem('info',JSON.stringify(info))
			}else{
				let info = JSON.parse(sessionStorage.getItem('info'))
				if(!info)return
				this.paperId = info.paperId
				this.competitionId = info.competitionId
				this.replay_type = info.replay_type
				this.times = info.times
				this.classroom_id = info.classroom_id
			}
		},
		mounted(){
			window.addEventListener('scroll', this.scrollEvent)
			this.initData()
		},
		methods:{
			//初始化数据
			initData: function(){
				let params = {
					competition_id:this.competitionId,
					paper_id:this.paperId,
					replay_type:this.replay_type,
					times:this.times,
					classroom_id:this.classroom_id,
				}
				checkPaperResultData(params).then(response=>{
					this.paper_title= response.data.paper_title
					this.questionList = response.data.info
					this.totalExercise = response.data.count
					this.student_score = response.data.student_score
					this.percent = response.data.percent
					this.student_name = response.data.student_name
					this.start_time = response.data.start_time
					this.submit_time = response.data.submit_time
					this.is_read = response.data.is_read
					this.currentList = this.questionList[0].paper_info
					this.singleScore = this.currentList[0].score
					this.questionType = this.currentList[0].paper_type
					this.setAnswerBtn(response.data.info,response.data.answer_info)
					this.getScore(response.data.info)
				})
			},
			//选择题目，id为题目id，type为题目类型,index为该题下标
			checkQuestion: function(ind,type,index){
				this.currentExercise = index
				this.currentIndex = ind
				this.questionType = type
				this.singleScore = this.answerBtn[index].score
			},
			//将所有题目提取出来组成答题卡
			setAnswerBtn: function(data,answer){
				let count = 0
				for(let i=0;i<data.length;i++){
					count += data[i].count_type
					if(data[i].paper_info.length){
						for(let j=0;j<data[i].paper_info.length;j++){
							let status = data[i].paper_info[j].status
							let paper_type = data[i].paper_info[j].paper_type
							if(paper_type===7||paper_type===8||paper_type===9){
								if(!answeIfNull(data[i].paper_info[j].student_answer,paper_type)){
									status = 0	
								}
							}
							let obj = {
								index:j,
								type:data[i].paper_info[j].paper_type,
								score:data[i].paper_info[j].score,
								status:status,
								is_view:data[i].paper_info[j].is_view,
								isRight:data[i].paper_info[j].right_and_wrong===0?0:1,
								student_score:data[i].paper_info[j].single_topic_score
							}
							this.answerBtn.push(obj)
						}
					}
				}
				this.totalExercise = count
			},
			//获取客观题分数和主观题分数
			getScore: function(data){
				let objArr = [1,2,3,4,5,6,10]
				let subArr = [7,8,9]
				for(let i=0;i<data.length;i++){
					let arr = {}
					if(objArr.includes(data[i].paper_type)){
						arr.get_score = data[i].get_score
						arr.single_score = data[i].single_score
						arr.count_type = data[i].count_type
						arr.paper_type = data[i].paper_type
						arr.typeName = returnQuestionType(data[i].paper_type)
						this.objective_score.push(arr)
					}else if(subArr.includes(data[i].paper_type)){
						arr.get_score = data[i].get_score
						arr.single_score = data[i].single_score
						arr.count_type = data[i].count_type
						arr.paper_type = data[i].paper_type
						arr.typeName = returnQuestionType(data[i].paper_type)
						this.subjective_score.push(arr)
					}
				}
			},
			//返回方法
			back: function(){
				if(window.history.length <= 1) {
	                this.$router.push({name:'entrance'})
	                return false
	            } else {
	                this.$router.go(-1)
	            }
			},
			//判断该题的状态,index为该题下标,status为该题状态,isRight为该题正确与否
			jugeStatus: function(index,status,isRight){
				let cls = ''
				if(this.currentExercise===index){
					cls += ' current-title'
				}
				if(!this.submit_time){
					return cls;
				}
				let arr = [7,8,9]
                if(arr.indexOf(this.answerBtn[index].type)>=0){
					if(!this.answerBtn[index].is_view){
                        cls += ' stay-read'
						return cls
					}
				}
				if(status===1){
					if(isRight){
						if(this.answerBtn[index].score===this.answerBtn[index].student_score){
							cls += ' completed'
						}else{
							cls += ' mistake'
						}
							
					}else{
						cls += ' mistake'
					}
				}
				return cls
			},
			
			//上一题
			prevQuestion: function(){
				if(this.currentExercise >0){
					this.currentExercise -= 1
					this.currentIndex = this.answerBtn[this.currentExercise].index
					this.questionType = this.answerBtn[this.currentExercise].type
				}
			},
			//下一题
			nextQuestion: function(){
				if(this.currentExercise < this.totalExercise){
					this.currentExercise += 1
					this.currentIndex = this.answerBtn[this.currentExercise].index
					this.questionType = this.answerBtn[this.currentExercise].type
				}
			},
			//返回顶部
			backTop() {
				resultBox.scrollIntoView()
			},
			scrollEvent (e) {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if(document.querySelector('#resultBox')){
					let offsetTop = document.querySelector('#resultBox').offsetTop
					if (scrollTop > offsetTop) {
					this.topTopFixed = true
					} else {
					this.topTopFixed = false
					}
				}
				
			},
		},
		filters:{
			returnType:function(val){
				return returnQuestionType(val)
			}
		}
	}
</script>

<style scoped="">
	@import url("../../assets/css/result.css");
</style>